var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNotificationAlertBlue = function SvgNotificationAlertBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 30,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.847,
    cy: 15,
    r: 15,
    fill: "#2E5896"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.327 7.468c0 1.144.936 2.132 2.184 2.132s2.184-.988 2.184-2.132-.936-2.132-2.184-2.132-2.184.988-2.184 2.132m2.21 4.212c-1.69 0-1.742.104-1.742.39v12.948c0 .286.052.39 1.742.39h.13c1.534 0 1.69-.104 1.69-.39V12.07c0-.286-.156-.39-1.69-.39z"
  })));
};
export { SvgNotificationAlertBlue as ReactComponent };
export default __webpack_public_path__ + "images/Notification_Alert_Blue.svg";